import { apiHost } from '../../../config';
import { post } from '../../requests';
import { StudentEditableFields } from '../../../types/Student';

export default async function createStudent(student: StudentEditableFields) {
  return post(`${apiHost}/api/teacher/users`, student);
}
